import { useState } from "react";
import { leerSesion } from "../api.ts";

/** Días del mes en que se recuerda (con suavidad) a quien no está obligado a activar la verificación en dos pasos. */
const DIAS_RECORDATORIO = [1, 15];
const ROLES_SUAVE = ["odontologo", "especialista"];

/**
 * Administración y dirección: aviso con los días que quedan para activar la verificación en dos pasos (desaparece al activarla).
 * Odontólogos y especialistas (no la tienen obligatoria): una invitación sin plazo que solo aparece dos días al mes (1 y 15) hasta que la activen.
 */
export function AvisoDosPasos({ ir }: { ir: (ruta: string) => void }) {
  const u = leerSesion()?.usuario;
  const dp = u?.dosPasos;
  const [oculto, setOculto] = useState(false);
  if (!u || !dp || dp.activo) return null;

  if (!dp.obligatorio) {
    if (oculto || dp.vinculada || !ROLES_SUAVE.includes(u.rol) || !DIAS_RECORDATORIO.includes(new Date().getDate())) return null;
    return (
      <section className="card" aria-labelledby="t-dos-pasos-suave">
        <div className="fila" style={{ justifyContent: "space-between", alignItems: "baseline", flexWrap: "wrap", gap: 8 }}>
          <h2 id="t-dos-pasos-suave" style={{ margin: 0 }}>Protege tu cuenta con la verificación en dos pasos</h2>
          <span className="chip">Recomendado</span>
        </div>
        <p className="muted" style={{ margin: 0, fontSize: 13 }}>
          Con tu cuenta se ven historias clínicas de tus pacientes. Además de tu contraseña, Donna pedirá un número de 6 dígitos de tu celular: así, aunque alguien se entere de tu contraseña, no puede entrar. Toma dos minutos y es opcional.
        </p>
        <div className="fila" style={{ flexWrap: "wrap" }}>
          <button className="btn pri" onClick={() => ir("configuracion/cuenta")}>Activarla ahora</button>
          <button className="btn" onClick={() => setOculto(true)}>Ahora no</button>
        </div>
      </section>
    );
  }

  const dias = dp.diasRestantes ?? 0;
  return (
    <section className="card" aria-labelledby="t-dos-pasos">
      <div className="fila" style={{ justifyContent: "space-between", alignItems: "baseline", flexWrap: "wrap", gap: 8 }}>
        <h2 id="t-dos-pasos" style={{ margin: 0 }}>Activa la verificación en dos pasos</h2>
        <span className="chip rojo">{dias > 0 ? `Te quedan ${dias} día${dias === 1 ? "" : "s"}` : "Plazo vencido"}</span>
      </div>
      <p className="muted" style={{ margin: 0, fontSize: 13 }}>
        Tu cuenta ve toda la información de la clínica. Además de tu contraseña, Donna pedirá un número de 6 dígitos de tu celular: así, aunque alguien se entere de tu contraseña, no puede entrar. Toma dos minutos.
      </p>
      <div><button className="btn pri" onClick={() => ir("configuracion/cuenta")}>Activarla ahora</button></div>
    </section>
  );
}
